import React from 'react'
import { Definition, SectionBody } from '@apexinternal/ui-components'
import { BoxProps } from '@chakra-ui/react'
import { isEmpty, startCase, lowerCase } from 'lodash'
import { AccountOwner } from 'types'
import {
  formatPhoneNumbers,
  formatDate,
  LONG_DATE_FORMAT,
  formatAddressStartCase,
} from 'utils'

export interface OwnerTableProps extends BoxProps {
  accountOwner?: AccountOwner
}

const OwnerTable = ({ accountOwner, ...rest }: OwnerTableProps) => {
  if (isEmpty(accountOwner) || !accountOwner) return null
  const {
    givenName,
    familyName,
    entityName,
    ownerType,
    dateOfBirth,
    taxId,
    mailingAddress,
    homeAddress,
    emailAddresses,
    phoneNumbers,
  } = accountOwner
  const ownerName = `${givenName} ${familyName} ${entityName}`
  const formattedHomeAddress = formatAddressStartCase(homeAddress)
    .filter(address => address !== '')
    .join('\n')
  const formattedMailingAddress = formatAddressStartCase(mailingAddress)
    .filter(address => address !== '')
    .join('\n')
  const formattedPhoneNumbers = formatPhoneNumbers(phoneNumbers).join('\n')

  return (
    <SectionBody {...rest}>
      {ownerName && (
        <Definition
          role="row"
          key="ownerName"
          data-testid="ownerName"
          term={`${startCase(lowerCase(ownerType))}`}
          definition={startCase(lowerCase(ownerName))}
          backgroundColor="gray.100"
          sx={{ dt: { fontWeight: 600 } }}
        />
      )}
      {dateOfBirth && (
        <Definition
          role="row"
          key="dateOfBirth"
          data-testid="dateOfBirth"
          term="Date of Birth"
          definition={formatDate(dateOfBirth, LONG_DATE_FORMAT)}
        />
      )}
      {taxId && (
        <Definition
          role="row"
          key="taxId"
          data-testid="taxId"
          term="Tax ID"
          definition={taxId}
        />
      )}
      {!isEmpty(formattedMailingAddress) && (
        <Definition
          role="row"
          key="mailingAddress"
          data-testid="mailingAddress"
          term="Mailing Address"
          definition={formattedMailingAddress}
          sx={{ whiteSpace: 'pre-line' }}
        />
      )}
      {!isEmpty(formattedHomeAddress) && (
        <Definition
          role="row"
          key="homeAddress"
          data-testid="homeAddress"
          term="Home Address"
          definition={formattedHomeAddress}
          sx={{ whiteSpace: 'pre-line' }}
        />
      )}
      {!isEmpty(emailAddresses) && (
        <Definition
          role="row"
          key="emailAddress"
          data-testid="emailAddress"
          term="Email"
          definition={emailAddresses.join('\n')}
          sx={{ whiteSpace: 'pre-line' }}
        />
      )}
      {!isEmpty(formattedPhoneNumbers) && (
        <Definition
          role="row"
          key="phoneNumber"
          data-testid="phoneNumber"
          term="Phone"
          definition={formattedPhoneNumbers}
          sx={{ whiteSpace: 'pre-line' }}
        />
      )}
    </SectionBody>
  )
}

export default OwnerTable
